// extracted by mini-css-extract-plugin
export default {"pageSection":"PageContent_pageSection__Ek5lp","introText":"PageContent_introText__cn5F1","title":"PageContent_title__WRbx3"};